module.exports = __webpack_public_path__ + "resources/img/img-danbiAi-m.37f8c7f4d96ec204f9ed459ff9a11637.png";